var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "advanced-slot-section" },
    [
      _c(
        "div",
        { staticClass: "add-tabs", attrs: { role: "tablist" } },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "button",
            {
              key: tab.id,
              staticClass: "add-tab",
              class: { "add-tab--active": _vm.activeTab === tab.id },
              attrs: {
                type: "button",
                role: "tab",
                "aria-selected": _vm.activeTab === tab.id,
              },
              on: {
                click: function ($event) {
                  _vm.activeTab = tab.id
                },
              },
            },
            [
              _c("span", {
                staticClass: "add-tab__icon",
                domProps: { innerHTML: _vm._s(tab.iconSvg) },
              }),
              _vm._v("\n      " + _vm._s(tab.label) + "\n    "),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "upload",
              expression: "activeTab === 'upload'",
            },
          ],
          staticClass: "tab-panel",
          attrs: { role: "tabpanel" },
        },
        [
          _c(
            "div",
            {
              ref: "uploadZone",
              staticClass: "upload-zone",
              class: { "upload-zone--active": _vm.isDragOver },
              on: {
                dragenter: function ($event) {
                  $event.preventDefault()
                  return _vm.onDragEnter.apply(null, arguments)
                },
                dragover: function ($event) {
                  $event.preventDefault()
                  return _vm.onDragOver.apply(null, arguments)
                },
                dragleave: function ($event) {
                  $event.preventDefault()
                  return _vm.onDragLeave.apply(null, arguments)
                },
                drop: function ($event) {
                  $event.preventDefault()
                  return _vm.onDrop.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "upload-zone__icon",
                  attrs: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" },
                  }),
                  _vm._v(" "),
                  _c("polyline", { attrs: { points: "17 8 12 3 7 8" } }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "12", x2: "12", y1: "3", y2: "15" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "upload-zone__title" }, [
                _vm._v("\n        Drop image(s) here or\n        "),
                _c("label", { staticClass: "upload-link" }, [
                  _vm._v("\n          upload\n          "),
                  _c("input", {
                    staticClass: "d-none",
                    attrs: { type: "file", multiple: "", accept: "image/*" },
                    on: { change: _vm.onFileInput },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "upload-zone__hint" }, [
                _vm._v("\n        or paste with ⌘V\n      "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "browse-btn",
                  attrs: { type: "button" },
                  on: { click: _vm.openSelectFolderModal },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n        Browse file library\n      "),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "product",
              expression: "activeTab === 'product'",
            },
          ],
          staticClass: "tab-panel",
          attrs: { role: "tabpanel" },
        },
        [
          _c(
            "div",
            { staticClass: "product-card" },
            [
              _c("div", { staticClass: "select-wrap product-card__type" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.productType,
                        expression: "productType",
                      },
                    ],
                    staticClass: "ui-input ui-input--xs",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.productType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "ASIN" } }, [
                      _vm._v("\n            ASIN\n          "),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "URL" } }, [
                      _vm._v("\n            URL\n          "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "select-chevron",
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [_c("path", { attrs: { d: "m6 9 6 6 6-6" } })]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "product-fetch-row" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.productValue,
                      expression: "productValue",
                    },
                  ],
                  staticClass: "ui-input ui-input--xs product-fetch-row__input",
                  attrs: {
                    type: "text",
                    placeholder:
                      _vm.productType === "URL"
                        ? "https://amazon.com/dp/B087CY8B2R"
                        : "B087CY8B2R",
                    disabled: _vm.productFetching,
                  },
                  domProps: { value: _vm.productValue },
                  on: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.fetchProduct.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.productValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-fetch",
                    attrs: {
                      type: "button",
                      disabled: _vm.productFetching || !_vm.productValue.trim(),
                    },
                    on: { click: _vm.fetchProduct },
                  },
                  [
                    _vm.productFetching
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _c("span", [_vm._v("Fetch")]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.productError
                ? _c("p", { staticClass: "product-error" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.productError) + "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fetchedImages.length
                ? [
                    _c("div", { staticClass: "product-stats" }, [
                      _c("span", { staticClass: "product-stats__text" }, [
                        _vm._v(
                          "\n            Fetched " +
                            _vm._s(_vm.fetchedImages.length) +
                            " · Selected " +
                            _vm._s(_vm.selectedCount) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "product-stats__action",
                          attrs: { type: "button" },
                          on: { click: _vm.toggleSelectAll },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.allSelected ? "Deselect all" : "Select all"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "product-grid" },
                      _vm._l(_vm.fetchedImages, function (img, i) {
                        return _c(
                          "button",
                          {
                            key: `fetched-${i}`,
                            staticClass: "product-grid__item",
                            class: {
                              "product-grid__item--selected": img.selected,
                            },
                            attrs: { type: "button", title: `#${i + 1}` },
                            on: {
                              click: function ($event) {
                                return _vm.toggleImageSelection(i)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "product-grid__img",
                              attrs: { src: img.displayUrl, alt: `#${i + 1}` },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "product-grid__check",
                                class: {
                                  "product-grid__check--selected": img.selected,
                                },
                              },
                              [_vm._v("\n              ✓\n            ")]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "describe",
              expression: "activeTab === 'describe'",
            },
          ],
          staticClass: "tab-panel",
          attrs: { role: "tabpanel" },
        },
        [
          _c("div", { staticClass: "describe-card" }, [
            _c("div", { staticClass: "describe-grid" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.slotName,
                    expression: "slotName",
                  },
                ],
                staticClass: "ui-input describe-grid__name",
                attrs: {
                  type: "text",
                  placeholder: "Name — e.g. Enhanced Hero Image",
                },
                domProps: { value: _vm.slotName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.slotName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "select-wrap describe-grid__category" },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.slotCategory,
                          expression: "slotCategory",
                        },
                      ],
                      staticClass: "ui-input ui-input--sm",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.slotCategory = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.categoryOptions, function (category) {
                      return _c(
                        "option",
                        { key: category, domProps: { value: category } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(category) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "select-chevron",
                      attrs: {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [_c("path", { attrs: { d: "m6 9 6 6 6-6" } })]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "describe-grid__dimensions" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.slotWidth,
                      expression: "slotWidth",
                    },
                  ],
                  staticClass: "ui-input ui-input--dim",
                  attrs: { type: "number", placeholder: "W" },
                  domProps: { value: _vm.slotWidth },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.slotWidth = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "dim-sep" }, [_vm._v("×")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.slotHeight,
                      expression: "slotHeight",
                    },
                  ],
                  staticClass: "ui-input ui-input--dim",
                  attrs: { type: "number", placeholder: "H" },
                  domProps: { value: _vm.slotHeight },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.slotHeight = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "dim-unit" }, [_vm._v("px")]),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.slotDescription,
                    expression: "slotDescription",
                  },
                ],
                staticClass: "ui-textarea describe-grid__description",
                attrs: {
                  placeholder:
                    "Description — e.g. A 3D version of a pack shot, showing the product out of the box",
                  rows: "4",
                },
                domProps: { value: _vm.slotDescription },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.slotDescription = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.slotAiDirection,
                    expression: "slotAiDirection",
                  },
                ],
                staticClass: "ui-textarea describe-grid__ai",
                attrs: {
                  placeholder:
                    "Default AI direction (optional) — reusable prompt to seed generation",
                  rows: "4",
                },
                domProps: { value: _vm.slotAiDirection },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.slotAiDirection = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "describe-footer" }, [
              _c("p", { staticClass: "describe-footer__hint" }, [
                _vm._v(
                  "\n          Also saved to your Image Types catalog.\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-create-slot",
                  attrs: { type: "button", disabled: !_vm.slotName.trim() },
                  on: { click: _vm.addDescribedSlot },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "M5 12h14" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M12 5v14" } }),
                    ]
                  ),
                  _vm._v("\n          Create & add slot\n        "),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("SelectFolderModal", {
        attrs: {
          mode: "default",
          "view-tabs": true,
          "modal-title": "Select images",
        },
        on: { onSelectedItems: _vm.onFileBrowserItemsSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }